module.exports = __webpack_public_path__ + "img/website-monitoring.55a777d3.png";